/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lens_LabelInputs */

const en_lens_label = /** @type {(inputs: Lens_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brands shown`)
};

/**
* | output |
* | --- |
* | "Brands shown" |
*
* @param {Lens_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const lens_label = /** @type {((inputs?: Lens_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lens_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lens_label(inputs)
});